export const Assignments = api => ({
  latest(slug) {
    return api.get(`/v1/profiles/${slug}/assignments/latest`)
  }
})
